export const GET_POSTS_REQUEST = 'GET_POSTS_REQUEST'
export const GET_POSTS = 'GET_POSTS'
export const POST_FAIL = 'POST_FAIL'
export const CREATE_POST = 'CREATE_POST'
export const UPDATE_POST = 'UPDATE_POST'
export const DELETE_POST = 'DELETE_POST'
export const LIKE_POST = 'LIKE_POST'
export const CHANGE_LIKE = 'CHANGE_LIKE'
export const GET_POST = 'GET_POST'
